import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import UploadAndCleanData from './upload/UploadAndCleanData';
import { styled } from '@mui/material/styles';
import { SystemContext } from "./context";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
            style={{ flexGrow: 1, display: value === index ? 'block' : 'none' }}
        >
            {value === index && (
                <Box sx={{p:2, height: '100%', overflow: 'auto' }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const CustomTabs = styled((props) => <Tabs {...props} />)(({ theme }) => ({
    "& .MuiTabs-flexContainer": {
        flexDirection: "column",
        alignItems: "stretch",
    },
}));

const CustomTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
      position: "relative",
      backgroundColor: "#152C73",
      color: "white",
      fontWeight: "bold",
      textTransform: "none",
      minHeight: 48,
      minWidth: 150,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.1rem", // Increased font size
      boxSizing: "border-box", // Ensure consistent box sizing
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.2)",
      },
      "&.Mui-selected": {
        backgroundColor: "white",
        color: "#152C73",
        boxShadow: "none", // Remove shadow
        margin: 0, // Reset margin
        padding: 0, // Reset padding
        border: "none", // Remove borders
        zIndex: 1, // Ensure selected tab is above others
        width: "100%", // Stretch to fill available space
      },
      "&:not(.Mui-selected)": {
        zIndex: 0, // Lower z-index for unselected tabs
      },
    })
  );
  
  

const VerticalTabs = ({ fetchAPI }) => {
    const [value, setValue] = React.useState(0);
    const { openDrawer } = React.useContext(SystemContext); // Make sure to call useContext correctly

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ display: 'flex', height: '100%'}}>
            <Box
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh'
                }}
            >
                <TabPanel value={value} index={0}>
                    <UploadAndCleanData fetchAPI={fetchAPI} />
                </TabPanel>
            </Box>
        </Box>
    );
};

export default VerticalTabs;
